module.exports = __webpack_public_path__ + "img/completion0.e043ae4d.svg";